import React from 'react';

import formatPhoneNumber from '../utility/formatting/formatPhoneNumber';
import Input from './Input';

type Props = {
    value?: string;
    onChange: (ev: any) => void;
};

type State = {
    value: string;
};

class PhoneNumberInput extends React.PureComponent<Props, State> {
    state = {
        value: this.props.value,
    };

    handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').substring(0, 10);

        this.setState({ value });

        e.target.value = value;
        this.props.onChange(e);
    };

    render() {
        return (
            <Input
                {...this.props}
                type="tel"
                value={formatPhoneNumber(this.state.value)}
                onChange={this.handleChange}
            />
        );
    }
}

export default PhoneNumberInput;
